/**
 * Bilingual copy for the ProductHero component.
 * `en` holds the exact original English strings; `km` mirrors them in Khmer.
 */
export const en = {
  talkToUs: 'Talk to us',
  userGuide: 'Guide',
  liveDemos: 'Live demos',
  demoVisitPrefix: 'Visit live demo at',
  usernameLabel: 'username:',
  passwordLabel: 'Password:',
};

export type Copy = typeof en;

export const km: Copy = {
  talkToUs: 'ទំនាក់ទំនងជាមួយយើង',
  userGuide: 'មគ្គុទ្ទេសក៍ប្រើប្រាស់',
  liveDemos: 'សាកល្បង demo ផ្ទាល់',
  demoVisitPrefix: 'សូមសាកល្បង demo ផ្ទាល់នៅ',
  usernameLabel: 'ឈ្មោះអ្នកប្រើប្រាស់:',
  passwordLabel: 'ពាក្យសម្ងាត់:',
};
